import React from "react";
import T from "prop-types";
import { Detail, DetailTable, Section } from "MODULES/shared/components";
import { get } from "lodash";
import { dollars } from "LIB/formatters/currency";
import { percent } from "LIB/formatters/number";

export function ConsignmentDetailsTable({ consignment }) {
  return (
    <Section title="Details" editable={false}>
      <DetailTable>
        <Detail
          label="Total Sold"
          value={dollars(get(consignment, "total_sold"))}
        />
        <Detail
          label="Consignor Percentage"
          value={percent(get(consignment, "consignor_percentage"), 100)}
        />
        <Detail
          label="Total Paid To Consignor"
          value={dollars(get(consignment, "total_paid"))}
        />
        <Detail
          label="Profit From Consignment"
          value={dollars(get(consignment, "profit"))}
        />
        <Detail
          label="Total Line Items Remaining"
          value={get(consignment, "total_line_items_remaining")}
        />
        <Detail
          label="Total Quantity Remaining"
          value={get(consignment, "total_qty_remaining")}
        />
      </DetailTable>
    </Section>
  );
}

ConsignmentDetailsTable.propTypes = {
  consignment: T.shape({
    part: T.shape({}),
    tag_date: T.string,
    serial_number: T.string,
    condition: T.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/ConsignmentDetailTable.jsx